import { render, staticRenderFns } from "./PacketType.vue?vue&type=template&id=404e84de"
import script from "./PacketType.vue?vue&type=script&lang=js"
export * from "./PacketType.vue?vue&type=script&lang=js"
import style0 from "./PacketType.vue?vue&type=style&index=0&id=404e84de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports